<template>
    <div class="employeeDataEdit">
        <ValidationObserver ref="formEmpleado">
            <div class="card mb-3">
                <div class="body">                      
                    <ul class="nav nav-tabs mb-1">
                        <li class="nav-item">
                            <button :class="'nav-link ' + ((selectedTab == 'datosPersonales') ? 'active' : '')" @click.prevent="selectedTab = 'datosPersonales'"><i class="ms-Icon ms-Icon--ContactInfo tab-icon align-middle"></i> 1. {{ $t('datosPersonales') }}</button>
                        </li>
                        <li class="nav-item d-none">
                            <button :class="'nav-link ' + ((selectedTab == 'datosBancarios') ? 'active' : '')" @click.prevent="selectedTab = 'datosBancarios'"><i class="ms-Icon ms-Icon--Group tab-icon align-middle"></i> 2. {{ $t('datosBancarios') }}</button>
                        </li>                           
                    </ul>              
                    <div v-if="selectedTab == 'datosPersonales'">
                        <div class="row clearfix">                                         
                            <div class="col-md-4 col-xs-12">
                                <span>{{ $t('siglaDomicilio') }}:</span>
                                <select id="select-sigla" v-model="lineaDiario.sigDomicilio" class="form-control" >
                                    <option v-for="sigla in siglas" v-bind:key="sigla.codSigla" v-bind:value="sigla.codSigla" >{{ sigla.descrSigla }}</option>
                                </select>                               
                            </div>                                
                            <div class="col-md-4 col-xs-12">
                                <ValidationProvider :rules="rules.requiredField" name="vpPais" v-slot="{ errors, valid, validated }"> 
                                    <div class="form-group" :class="{'error': !valid && validated}">
                                        <span><strong>{{ $t('pais') }}:</strong></span>
                                        <div :class="{'valid': valid && validated}">
                                            <select id="select-pais" v-model="lineaDiario.codPais" class="form-control" @change="changePais">
                                                <option v-for="pais in paises" v-bind:key="pais.codPais" v-bind:value="pais.codPais" >{{ pais.nombrePais }}</option>
                                            </select>  
                                        </div>
                                        <span class="displayError">{{ errors[0] }}</span>       
                                    </div>
                                </ValidationProvider>                         
                            </div>
                            <div class="col-md-4 col-xs-12">
                                <ValidationProvider :rules="rules.requiredField" name="vpEstadoCivil" v-slot="{ errors, valid, validated }"> 
                                    <div class="form-group" :class="{'error': !valid && validated}">
                                        <span><strong>{{ $t('estadoCivil') }}:</strong></span> 
                                        <div :class="{'valid': valid && validated}">
                                            <select v-model="lineaDiario.estadoCivil" class="form-control mb-1">
                                                <option value="-1"></option>
                                                <option value="0">{{ $t('estadoCivil0') }}</option>
                                                <option value="1">{{ $t('estadoCivil1') }}</option>
                                                <option value="2">{{ $t('estadoCivil2') }}</option>
                                                <option value="3">{{ $t('estadoCivil3') }}</option>
                                                <option value="4">{{ $t('estadoCivil4') }}</option>
                                            </select>      
                                        </div>
                                        <span class="displayError">{{ errors[0] }}</span>       
                                    </div>
                                </ValidationProvider>                     
                            </div>
                            <div class="col-md-4 col-xs-12">                                    
                                <span>{{ $t('domicilio') }}:</span>                                            
                                <input name="domicilio" v-model="lineaDiario.domicilio" maxlength="40" class="form-control"/>  
                            </div>
                            <div class="col-md-4 col-xs-12">
                                <span>{{ $t('provincia') }}:</span>
                                <select id="select-provincia" v-model="lineaDiario.codProvincia" class="form-control" @change="changeProvincia">
                                    <option v-for="provincia in provincias" v-bind:key="provincia.codProvincia" v-bind:value="provincia.codProvincia" >{{ provincia.nombreProvincia }}</option>
                                </select>                           
                            </div>
                            <div class="col-md-4 col-xs-12">
                                <ValidationProvider :rules="rules.requiredField" name="vpSexo" v-slot="{ errors, valid, validated }"> 
                                    <div class="form-group" :class="{'error': !valid && validated}">
                                        <span><strong>{{ $t('sexo') }}:</strong></span>
                                        <div :class="{'valid': valid && validated}">
                                            <select v-model="lineaDiario.sexo" class="form-control mb-1">
                                                <option value="*NULL"></option>
                                                <option value="0">{{ $t('hombre') }}</option>
                                                <option value="1">{{ $t('mujer') }}</option>
                                            </select>     
                                        </div>
                                        <span class="displayError">{{ errors[0] }}</span>       
                                    </div>
                                </ValidationProvider>                            
                            </div>
                            <div class="col-md-4 col-xs-12 pb-3">
                                <span>{{ $t('tipoNum') }}:</span>
                                <select v-model="lineaDiario.tipoDeNumeracion" class="form-control mb-1">
                                    <option value="0"></option>
                                    <option value="1">{{ $t('tipoNum1') }}</option>
                                    <option value="2">{{ $t('tipoNum2') }}</option>
                                    <option value="3">{{ $t('tipoNum3') }}</option>
                                    <option value="4">{{ $t('tipoNum4') }}</option>
                                </select>                              
                            </div>
                            <div class="col-md-4 col-xs-12 pb-3">
                                <span>{{ $t('poblacion') }}:</span>
                                <select id="select-poblacion" v-model="lineaDiario.codPoblacion" class="form-control">
                                    <option v-for="poblacion in poblaciones" v-bind:key="poblacion.codPoblacion" v-bind:value="poblacion.codPoblacion" >{{ poblacion.nombrePoblacion }}</option>
                                </select>                                  
                            </div>
                            <div class="col-md-4 col-xs-12 pb-3">
                                <span>{{ $t('nacionalidad') }}:</span>
                                <select id="select-nacionalidad" v-model="lineaDiario.nacionalidad" class="form-control">
                                    <option v-for="nacionalidad in nacionalidades" v-bind:key="nacionalidad.codPais" v-bind:value="nacionalidad.codPais" >{{ nacionalidad.nacionalidad }}</option>
                                </select>                             
                            </div>
                            <div class="col-md-4 col-xs-12">
                                <span>{{ $t('casa') }}:</span>
                                <input name="domicilio" maxlength="4" v-model="lineaDiario.casa" class="form-control"/>                               
                            </div>
                            <div class="col-md-4 col-xs-12">
                                <span>{{ $t('telefono') }}:</span>
                                <div class="input-group mb-0">
                                    <input name="telefono" v-model="lineaDiario.telefono" class="form-control"/>      
                                    <div class="input-group-append">
                                        <span class="input-group-text form-control">
                                            <i class="ms-Icon ms-Icon--Phone"></i>
                                        </span>
                                    </div>   
                                </div>                      
                            </div>
                            <div class="col-md-4 col-xs-12">
                                <ValidationProvider :rules="rules.perDiscapacidad" name="vpDiscapacidad" v-slot="{ errors, valid, validated }"> 
                                    <div class="form-group" :class="{'error': !valid && validated}">
                                        <span>{{ $t('porGradoDiscapacidad') }}:</span>
                                        <div :class="{'valid': valid && validated}">
                                            <div class="input-group mb-0">
                                                <input type="number" min="0" max="100" name="porGradoDiscapacidad" v-model="lineaDiario.gradoDiscapacidad" class="form-control"/>      
                                                <div class="input-group-append">
                                                    <span class="input-group-text form-control">
                                                        <i class="ms-Icon ms-Icon--CalculatorPercentage"></i>
                                                    </span>
                                                </div>   
                                            </div>     
                                        </div>
                                        <span class="displayError">{{ errors[0] }}</span>       
                                    </div>
                                </ValidationProvider>                        
                            </div>
                            <div class="col-md-4 col-xs-12 pb-3">
                                <span>{{ $t('bloque') }}:</span>
                                <input name="bloque" MaxLength="3" v-model="lineaDiario.bloque" class="form-control"/>                               
                            </div>
                            <div class="col-md-4 col-xs-12 pb-3">
                                <span>{{ $t('telefonoMovil') }}:</span>
                                <div class="input-group mb-0">
                                    <input name="telefonoMovil" v-model="lineaDiario.telefonoMovil" class="form-control"/>      
                                    <div class="input-group-append">
                                        <span class="input-group-text form-control">
                                            <i class="ms-Icon ms-Icon--CellPhone"></i>
                                        </span>
                                    </div>   
                                </div>                      
                            </div>
                            <div class="col-md-4 col-xs-12 pb-3">
                                <span>{{ $t('fechaIniDisc') }}:</span>
                                <InputDate v-model="fechaInicioDiscapacidadProp" @select="(v) => selectDate(v)" @click="(v) => clickInputDate(v)"></InputDate>
                            </div>
                            <div class="col-md-4 col-xs-12">
                                <span>{{ $t('portal') }}:</span>
                                <input name="portal" MaxLength="3" v-model="lineaDiario.portal" class="form-control"/>                               
                            </div>
                            <div class="col-md-4 col-xs-12">
                                <ValidationProvider :rules="rules.email" name="vpEmail" v-slot="{ errors, valid, validated }"> 
                                    <div class="form-group" :class="{'error': !valid && validated}">
                                        <span>{{ $t('email') }}:</span>
                                        <div :class="{'valid': valid && validated}">
                                            <div class="input-group mb-0">
                                                <input name="email" v-model="lineaDiario.email" class="form-control"/>      
                                                <div class="input-group-append">
                                                    <span class="input-group-text form-control">
                                                        <i class="ms-Icon ms-Icon--Mail"></i>
                                                    </span>
                                                </div>   
                                            </div>   
                                        </div>
                                        <span class="displayError">{{ errors[0] }}</span>       
                                    </div>
                                </ValidationProvider>                   
                            </div>
                            <div class="col-md-4 col-xs-12">                                                                  
                            </div>
                            <div class="col-md-4 col-xs-12 pb-3">
                                <span>{{ $t('escalera') }}:</span>
                                <input name="escalera" MaxLength="4" v-model="lineaDiario.escalera" class="form-control"/>                               
                            </div>
                            <div class="col-md-4 col-xs-12">                                                                
                            </div>
                            <div class="col-md-4 col-xs-12">                                                     
                            </div>
                            <div class="col-md-4 col-xs-12 pb-3">
                                <span>{{ $t('piso') }}:</span>
                                <input name="piso" MaxLength="4" v-model="lineaDiario.piso" class="form-control"/>                               
                            </div>
                            <div class="col-md-4 col-xs-12">                                                               
                            </div>
                            <div class="col-md-4 col-xs-12">                                                               
                            </div>
                            <div class="col-md-4 col-xs-12 pb-3">
                                <span>{{ $t('puerta') }}:</span>
                                <input name="puerta" MaxLength="4" v-model="lineaDiario.puerta" class="form-control"/>                               
                            </div>
                            <div class="col-md-4 col-xs-12">                                                               
                            </div>
                            <div class="col-md-4 col-xs-12">                                                               
                            </div>
                            <div class="col-md-4 col-xs-12">
                                <span>{{ $t('cp') }}:</span>
                                <input name="cp" MaxLength="5" v-model="lineaDiario.codPostal" class="form-control"/>                               
                            </div>
                            <div class="col-md-4 col-xs-12">                                                               
                            </div>
                            <div class="col-md-4 col-xs-12">                                                               
                            </div>
                            
                        </div>                            
                    </div>     
                    <div v-if="selectedTab == 'datosBancarios'">
                        <div class="row">
                            <div class="col-md-4 col-xs-12 pb-3">                  
                                <span>{{ $t('cuentaCorriente') }}</span>  
                                <div class="input-group">               
                                    <input name="cc1" maxlength="4" v-model="lineaDiario.codBanco" v-on:input="ccValidation" class="form-control"/> 
                                    <input name="cc2" maxlength="4" v-model="lineaDiario.codSucursal" v-on:input="ccValidation" class="form-control"/> 
                                    <input name="cc3" maxlength="2" v-model="lineaDiario.digitoControl" v-on:input="ccValidation" class="form-control"/> 
                                    <input name="cc4" maxlength="10" v-model="lineaDiario.numCuenta" v-on:input="ccValidation" class="form-control"/> 
                                </div>   
                                <div v-if="!validCC" class="pt-3 col-md-10">
                                    <div class="row">
                                        <div class="col-md-7 col-xs-12">  
                                            <BAlert show variant="warning" class="p-1">{{ $t('dcIncorrecto') }}</BAlert>
                                        </div>  
                                        <div class="col-md-5 col-xs-12">
                                            <BAlert v-if="digitoCorrecto != ''" class="p-1" show variant="info">{{ $t('digitoCorrecto') }}: {{ digitoCorrecto }}</BAlert>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4 col-xs-12">             
                                <ValidationProvider :rules="rules.iban" name="vpControlIban" v-slot="{ errors, valid, validated }"> 
                                    <div class="form-group" :class="{'error': !valid && validated}">     
                                        <span>{{ $t('digitoControlIban') }}</span>       
                                        <div :class="{'valid': valid && validated}">          
                                            <input name="codSwift" maxlength="2" v-model="lineaDiario.digitoControlIban" class="form-control"/>  
                                        </div>
                                        <span class="displayError">{{ errors[0] }}</span>       
                                    </div>
                                </ValidationProvider> 
                            </div>      
                        </div>
                        
                        <div class="row">
                            <div class="col-md-4 col-xs-12">   
                                <ValidationProvider :rules="rules.swift" name="vpSwift" v-slot="{ errors, valid, validated }"> 
                                    <div class="form-group" :class="{'error': !valid && validated}">            
                                        <span>{{ $t('codSwift') }}</span>  
                                        <div :class="{'valid': valid && validated}">                
                                            <input name="codSwift" v-model="lineaDiario.codSwift" MaxLength="11" class="form-control"/>  
                                        </div>
                                        <span class="displayError">{{ errors[0] }}</span>       
                                    </div>
                                </ValidationProvider> 
                            </div>
                        </div>                            
                    </div>                              
                </div>
            </div> 
        </ValidationObserver>
        <div class="row clearfix">                            
            <div class="col-md">
                <a class="btn btn-primary waves-effect waves-light btn-submit-success validate-tab validate-loading" @click.prevent="enviar()">{{ $t('enviar') }}</a>
                <router-link to="/employee" class="ml-1 btn btn-secondary waves-effect waves-light btn-submit-cancel">{{ $t('cancelar') }}
                </router-link>
            </div>
        </div>
        <Datepicker @select="(v) => selectDate(v)" ref="modaldatepicker"></Datepicker>
        <ModalAuthenticator ref="authenticator" @getCode="getCodeAuthenticator" />
    </div>
</template>
    
<style scoped>
#FotoUsuario {
    width: 170px;
}
</style>

<script>
import ModalAuthenticator from '@/components/ModalAuthenticator.vue'
import { BAlert } from 'bootstrap-vue'
import { employeeService } from '@/api/employee';
import moment from 'moment';
import Datepicker from '@/components/common/mmDatepicker.vue';
import InputDate from '@/components/common/mmInputDate.vue';
import { rules } from "@/_helpers/validations/validate-employee";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
    name: 'employeeDataEdit',
    props: {
        estadosCivilesProp: Object,
    },
    components: {
        ModalAuthenticator,
        Datepicker,
        InputDate,
        BAlert,
        ValidationObserver,
        ValidationProvider
    },
    data(){
        return {
            rules,
            fechaInicioDiscapacidadProp: '',
            selectedTab: 'datosPersonales',
            lineaDiario: {},
            estadosCiviles: this.estadosCiviles,
            siglas: {},
            poblaciones: {},
            provincias: {},
            paises: {},
            nacionalidades: {},
            validationError: '',
            validCC: true,
            digitoCorrecto: ''
        }
    },
    async created () {
        this.lineaDiario = await employeeService.getDataEmployeeWithDiario();
        this.siglas = await employeeService.getSiglas();        
        this.paises = await employeeService.getPaises();
        this.nacionalidades = await employeeService.getNacionalidades();
        this.camposLibres = await employeeService.getCamposLibres();
        this.fechaInicioDiscapacidadProp = this.lineaDiario.fechaInicioDiscapacidad;

        if (this.lineaDiario.pais != ''){
            this.provincias = await employeeService.getProvincias(this.lineaDiario.codPais);
            if (this.lineaDiario.provincia != '')
                this.poblaciones = await employeeService.getPoblaciones(this.lineaDiario.codProvincia);
        }
        
    },
    methods: {
        async changePais(){            
            this.provincias = await employeeService.getProvincias(this.lineaDiario.codPais);
            this.poblaciones = {};
        },
        async changeProvincia(){
            this.poblaciones = await employeeService.getPoblaciones(this.lineaDiario.codProvincia);
        },
        async enviar() {
            if(await this.$refs.formEmpleado.validate())
            {
                if(this.$Params.mfa_datos && this.$Params.user_authenticator==1)
                    this.$refs.authenticator.openModal();
                else
                    this.enviarData();
            }
        },
        async enviarData() {
            if (this.validCC) {
                if (!this.fechaInicioDiscapacidadProp || this.fechaInicioDiscapacidadProp == '') this.lineaDiario.fechaInicioDiscapacidad = '1753-01-01T00:00:00.000';                
                let response = await employeeService.postEmployeeData(this.lineaDiario);
                if(response)
                    this.$router.push('/employee');                       
                
            }
            else {
                this.selectedTab = 'datosBancarios';
            }   
        },
        getCodeAuthenticator(data) 
        {
            this.lineaDiario.code = data.code;
            this.enviarData();
        },
        clickInputDate(value) {
            this.$refs.modaldatepicker.openModal(value);    
        },
        selectDate(value) {
            console.log(value)
            console.log(moment)
            /*if (!value.includes('_')){
                this.fechaInicioDiscapacidadProp = moment(String(value), 'DD/MM/YYYY').format('DD/MM/YYYY'); 
                this.lineaDiario.fechaInicioDiscapacidad = moment(String(value), 'DD/MM/YYYY').format('YYYY-MM-DD[T]HH:mm:ss');
            }*/
        },
        ccValidation() {
            var entidad = this.lineaDiario.codSucursal;
            var banco = this.lineaDiario.codBanco;
            var dc = this.lineaDiario.digitoControl;
            var cc = this.lineaDiario.numCuenta;
            
            if (entidad == "" && banco == "" && dc == "" && cc == "") this.validCC = true;
            else
            if (entidad.length != 4 || banco.length != 4 || dc.length != 2 || cc.length != 10) this.validCC = false;
            else {
                var valores = new Array(1, 2, 4, 8, 5, 10, 9, 7, 3, 6);
                var controlCS = 0;
                var controlCC = 0;
                for (var i = 0; i <= 7; i++) {   
                    controlCS += parseInt((banco + "" + entidad).charAt(i)) * valores[i + 2];
                }
                controlCS = 11 - (controlCS % 11);
                if (controlCS == 11) controlCS = 0;
                else if (controlCS == 10) controlCS = 1;

                for (i = 0; i < 10; i++)
                    controlCC += parseInt(cc.charAt(i)) * valores[i];
                controlCC = 11 - (controlCC % 11);
                if (controlCC == 11) controlCC = 0;
                else if (controlCC == 10) controlCC = 1;

                this.validCC = ((controlCS + "" + controlCC) == dc);
                                
                if (this.validCC)
                {
                    this.calculateIban(banco, entidad, dc, cc);
                }
                else
                {
                    this.digitoCorrecto = controlCS + "" + controlCC;
                }
            }

            if (!this.validCC) {
                this.lineaDiario.digitoControlIban = '';
            }
        },
        calculateIban(entidad, banco, dc, cc)
        {
            var iban = entidad + "" + banco + "" + dc + "" + cc;
            var num = iban + "142800";

            var get_first_value = '0' + (98 - (((((((iban.slice(0, 8) % 97) + '' + iban.slice(8, 16)) % 97) + '' + num.slice(16, 24)) % 97) + '' + num.slice(24, 26)) % 97));

            var get_second_value = get_first_value.slice(-2);

            this.lineaDiario.digitoControlIban = get_second_value;
        }
    }
}
</script>